export const h = {
  site_title: "得胜彩印官网",

  //首页
  index: {
    product_category_title: "满足“一站式购买”需求",
    product_category_desc1: "我们提供丰富多元的包装产品，涵盖折叠纸盒、胶片盒、高端礼盒、",
    product_category_desc2: "精品纸袋、智能及个性化产品、促销工具等多样选择",

    our_advantage_title: "我们的优势",
    our_advantage_desc1: "始终以客户需求为重心，不断追求技术创新和运作卓越，",
    our_advantage_desc2: "努力成为品牌客户持续发展的首选合作供应商",

    latest_news_title: "最新动态"
  },

};



// WEBPACK FOOTER //
// ./src/i18n/lan/en.js